module.exports = __webpack_public_path__ + "static/media/logo.88daeed5.png";